import { render, staticRenderFns } from "./CabeceraModalCrearBase.vue?vue&type=template&id=49244bad&"
import script from "./CabeceraModalCrearBase.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalCrearBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports